module.exports = __webpack_public_path__ + "img/folder-check.d88711c9.svg";